module.exports = __webpack_public_path__ + "static/media/image_6.d3fd6f11.png";